import { render, staticRenderFns } from "./PanelNavigation.vue?vue&type=template&id=7096081b&scoped=true&"
import script from "./PanelNavigation.vue?vue&type=script&lang=js&"
export * from "./PanelNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PanelNavigation.vue?vue&type=style&index=0&id=7096081b&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7096081b",
  null
  
)

export default component.exports